/**
 * 海报尺寸预览组件
 * @author tanglinxia
 * @since 21/09/09
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './preview-size.less';

const MAX_WIDTH = 320;
const MAX_HEIGHT_NORMAL = 568;
const MAX_HEIGHT_IPX = 628;
const SCREEN_RATIO = MAX_WIDTH / MAX_HEIGHT_NORMAL;

class PreviewSize extends Component {
  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = {
      isIpxType: false,
    };
  }

  renderPosterSize() {
    const { isIpxType } = this.state;
    const { width, height } = this.props;
    let aspectRatio = width / height;
    let newWidth, newHeight;
    if (aspectRatio > SCREEN_RATIO) {
      newWidth = MAX_WIDTH;
      newHeight = newWidth / aspectRatio;
    } else {
      newHeight = isIpxType ? MAX_HEIGHT_IPX : MAX_HEIGHT_NORMAL;
      newWidth = newHeight * aspectRatio;
    }

    return {
      width: `${newWidth}px`,
      height: `${newHeight}px`,
    };
  }

  render() {
    const { isIpxType } = this.state;
    return (
      <div className="preview-size">
        <div className="toggle-btns">
          <div
            className={`toggle-btn ${isIpxType ? '' : 'active'}`}
            onClick={() => {
              this.setState({ isIpxType: false });
            }}>
            <span>常规屏</span>
          </div>
          <div
            className={`toggle-btn ${isIpxType ? 'active' : ''}`}
            onClick={() => {
              this.setState({ isIpxType: true });
            }}>
            <span>全面屏</span>
          </div>
        </div>
        <div className={`preview-container ${isIpxType ? 'ipx' : ''}`}>
          <div className="phone-bg"></div>
          <div className="bg-color"></div>
          <div className="watermark-container">
            <div className="watermark"></div>
          </div>
          <div className="poster-content">
            <div className="poster-size" style={this.renderPosterSize()}></div>
          </div>
        </div>
      </div>
    );
  }
}

export default PreviewSize;
